const INVALID_TIMER_ID = Math.MIN_SAFE_INTEGER;

/**
 * Responsible for managing the render cycle that allows changes to the active viewport state to propagate to tracked viewports.
 */
export class Timer {
  constructor (monitor, synchronizer) {
    this._monitor = monitor;
    this._synchronizer = synchronizer;
    this._timerId = INVALID_TIMER_ID;
  }

  /**
     * Commands the timer instance to start monitoring the selected viewport and sync the others.
     */
  start () {
    if (this._timerId === INVALID_TIMER_ID) {
      this._run();
    }
  }

  /**
     * Helper method to enable the timer's loop. Not meant to be called externally.
     * @private
     */
  _run () {
    this._timerId = window.requestAnimationFrame(() => {
      if (this._monitor.hasChanged) {
        this._synchronizer.sync(this._monitor.deltaState);
        this._monitor.clearChanges();
      }
      this._run();
    });
  }

  /**
     * Cancels the timer loop if running.
     */
  stop () {
    if (this._timerId !== INVALID_TIMER_ID) {
      window.cancelAnimationFrame(this._timerId);
      this._timerId = INVALID_TIMER_ID;
    }
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/manual-sync/Timer.js